export const DOCUMENT_TYPE = {
  PASSPORT: "Passport",
  BIRTH_CERTIFICATE: "BirthCertificate",
  DRIVERS_LICENCE: "DriversLicence",
};

export const DOCUMENT_TYPE_LABEL = {
  [DOCUMENT_TYPE.PASSPORT]: "Passport",
  [DOCUMENT_TYPE.BIRTH_CERTIFICATE]: "Birth Certificate",
  [DOCUMENT_TYPE.DRIVERS_LICENCE]: "Drivers Licence",
};

export const DOCUMENT_TYPE_OPTIONS = [
  { label: DOCUMENT_TYPE_LABEL[DOCUMENT_TYPE.PASSPORT], value: DOCUMENT_TYPE.PASSPORT },
  { label: DOCUMENT_TYPE_LABEL[DOCUMENT_TYPE.BIRTH_CERTIFICATE], value: DOCUMENT_TYPE.BIRTH_CERTIFICATE },
  { label: DOCUMENT_TYPE_LABEL[DOCUMENT_TYPE.DRIVERS_LICENCE], value: DOCUMENT_TYPE.DRIVERS_LICENCE },
];
